var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0422363,
    y: 0.50708,
    width: 30.9859,
    height: 30.9859,
    rx: 15.493,
    fill: "#D4DBE9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_1937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8994 10.4807H15.7991L15.2445 9.42434C14.954 8.89617 14.4258 8.55286 13.8184 8.55286H9.17055C8.27266 8.55286 7.55963 9.26588 7.55963 10.1638V21.8363C7.55963 22.7342 8.27266 23.4472 9.17055 23.4472H21.9258C22.8237 23.4472 23.5367 22.7342 23.5367 21.8363V12.0916C23.5367 11.1937 22.7973 10.4807 21.8994 10.4807ZM22.3484 21.8363C22.3484 22.074 22.1635 22.2588 21.9258 22.2588H9.17055C8.93287 22.2588 8.74801 22.074 8.74801 21.8363V10.1638C8.74801 9.9261 8.93287 9.74124 9.17055 9.74124H13.8184C13.9769 9.74124 14.1089 9.82046 14.1882 9.97891L14.9276 11.3522C15.0332 11.537 15.2445 11.6691 15.4558 11.6691H21.9258C22.1635 11.6691 22.3484 11.8539 22.3484 12.0916V21.8363Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4364 17.0036L16.1424 18.2713V14.4156C16.1424 14.0987 15.8783 13.8082 15.535 13.8082C15.1917 13.8082 14.9276 14.0723 14.9276 14.4156V18.2977L13.6072 17.0036C13.3695 16.766 12.9998 16.766 12.7621 17.0036C12.5244 17.2413 12.5244 17.611 12.7621 17.8487L15.0861 20.1198C15.1917 20.2255 15.3501 20.2783 15.5086 20.2783C15.667 20.2783 15.7991 20.2255 15.9311 20.1198L18.2551 17.8487C18.4928 17.611 18.4928 17.2413 18.2551 17.0036C18.0438 16.766 17.6741 16.766 17.4364 17.0036Z",
    fill: "#284993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_1937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9014,
    height: 16.9014,
    fill: "white",
    transform: "translate(7.08429 7.54932)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadFile);
export default __webpack_public_path__ + "static/media/icon-downloadFile.c78a119b93bab9e47f2d0febecc8debe.svg";
export { ForwardRef as ReactComponent };